"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainRenderer = exports.HeaderFooterRenderer = exports.MainHeaderFooterRenderer = void 0;
var tslib_1 = require("tslib");
var renderer_class_names_1 = require("../../../../core/canvas/renderer-class-names");
var number_1 = require("@devexpress/utils/lib/utils/map/number");
var document_renderer_1 = require("../common/document-renderer");
var base_renderer_1 = require("./base-renderer");
var dom_1 = require("@devexpress/utils/lib/utils/dom");
var MainHeaderFooterRenderer = (function (_super) {
    tslib_1.__extends(MainHeaderFooterRenderer, _super);
    function MainHeaderFooterRenderer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MainHeaderFooterRenderer.prototype.handlePageHide = function (_pageIndex) {
        return true;
    };
    MainHeaderFooterRenderer.prototype.activateElement = function (pageAreaElement) {
        if (!pageAreaElement)
            return false;
        dom_1.DomUtils.removeClassName(pageAreaElement, renderer_class_names_1.RendererClassNames.BLACKOUT);
        return true;
    };
    MainHeaderFooterRenderer.prototype.deactivateElement = function (pageAreaElement) {
        dom_1.DomUtils.addClassName(pageAreaElement, renderer_class_names_1.RendererClassNames.BLACKOUT);
    };
    return MainHeaderFooterRenderer;
}(base_renderer_1.BaseRenderer));
exports.MainHeaderFooterRenderer = MainHeaderFooterRenderer;
var HeaderFooterRenderer = (function (_super) {
    tslib_1.__extends(HeaderFooterRenderer, _super);
    function HeaderFooterRenderer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderFooterRenderer.prototype.handlePageRender = function (pageIndex, _force) {
        var _this = this;
        var cacheElement = this.renderer.cache[pageIndex];
        var layoutPage = this.renderer.layout.pages[pageIndex];
        if (!cacheElement || !layoutPage)
            return false;
        number_1.NumberMapUtils.forEach(cacheElement.otherAreas, function (paElement, elemSubDocId) {
            var pa = layoutPage.otherPageAreas[elemSubDocId];
            if (pa && pa.subDocument.isHeaderFooter())
                if (_this.isHeaderFooterActive(layoutPage))
                    _this.activateElement(paElement);
                else
                    _this.deactivateElement(paElement);
        });
    };
    return HeaderFooterRenderer;
}(MainHeaderFooterRenderer));
exports.HeaderFooterRenderer = HeaderFooterRenderer;
var MainRenderer = (function (_super) {
    tslib_1.__extends(MainRenderer, _super);
    function MainRenderer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MainRenderer.prototype.handlePageRender = function (pageIndex, _force) {
        var cacheElement = this.renderer.cache[pageIndex];
        return cacheElement &&
            this.applyToMainPageAreas(cacheElement, this.isActive() ? this.activateElement : this.deactivateElement);
    };
    MainRenderer.prototype.applyToMainPageAreas = function (cacheElement, applier) {
        if (!document_renderer_1.DocumentRenderer.isPageElementConsiderAllContainers(cacheElement.page))
            return false;
        var mainPageAreasElements = document_renderer_1.DocumentRenderer.getMainPageAreaContainerCore(cacheElement.page).childNodes;
        for (var paIndex = 0, paNode = void 0; paNode = mainPageAreasElements[paIndex]; paIndex++)
            applier.call(this, paNode);
        return true;
    };
    MainRenderer.prototype.isActive = function () {
        if (this.newSubDocumentInfo.isMain)
            return true;
        if (!this.newSubDocumentInfo.isTextBox)
            return false;
        return this.newSubDocumentInfo.parentSubDocumentId == 0;
    };
    return MainRenderer;
}(MainHeaderFooterRenderer));
exports.MainRenderer = MainRenderer;
